import { loaders } from 'entities';

import { Column, Skeleton } from 'components/Blocks';

import { SuggestionCard, useSuggestionModal } from '../components';
import { sortByProperty } from 'utils/array';

export function OpenSuggestions() {
  const { openSuggestion } = useSuggestionModal();

  const suggestions = loaders.feedback.allOpenSuggestions.use({
    defaultValue: [],

    parser: (suggestions) =>
      sortByProperty(suggestions, 'upVotes', { upVotes: (a, b) => b.length - a.length }),

    refreshMinutes: 1,
  });

  if (suggestions.errorOrLoading) return <Skeleton quantity={8} height={42} />;

  return (
    <>
      <Column>
        {suggestions.data.map((suggestion) => (
          <SuggestionCard
            key={suggestion.id}
            suggestion={suggestion}
            openSuggestion={openSuggestion}
            updateSuggestion={(newSug) =>
              suggestions.overwrite((old) =>
                old.map((s) =>
                  s.id === suggestion.id ? (typeof newSug === 'function' ? newSug(s) : newSug) : s,
                ),
              )
            }
          />
        ))}
      </Column>
    </>
  );
}
